import { SubmissionStatus } from '@assessments/shared'
import type { BadgeTone } from '@/components/ui/badge'

/**
 * One vocabulary for an assessment's submission status on the Manage Assessments page,
 * shared by the card badge and its action. Each map is a total Record, so adding a
 * status fails the type-check here rather than rendering an unlabelled card.
 */
export const SUBMISSION_STATUS_BADGE: Record<SubmissionStatus, { label: string; tone: BadgeTone }> =
  {
    [SubmissionStatus.InProgress]: { label: 'In Progress', tone: 'active' },
    [SubmissionStatus.NotStarted]: { label: 'Now Open', tone: 'open' },
    [SubmissionStatus.Submitted]: { label: 'Submitted', tone: 'submitted' },
  }

/** Action label for a user who may edit; read-only users always see "View". */
export const SUBMISSION_STATUS_EDITOR_ACTION: Record<SubmissionStatus, string> = {
  [SubmissionStatus.InProgress]: 'Continue',
  [SubmissionStatus.NotStarted]: 'Begin',
  [SubmissionStatus.Submitted]: 'View',
}
